export const EVENT_BATCH_DEBOUNCE_TIME_MS = 500;
